import React from 'react';
import { ButtonGroup } from 'baseui/button-group';
import { IDummyProps } from './types';
import { overrides as customOverrides } from './overrides';
import { useStyletron } from '../../Themes';
import { firstButtonStyles, buttonBaseStyles } from './styles';
import { mergeOverrides } from 'baseui';
import * as meta from '../../meta-data.json';

export const ToolbarButton = (props: any) => {
	const { item, childrenProps, disableKeyboardSupport = false, dataKey, hideLabel, ...rest } = props;

	const focusNextElement = (e: any, _dataKey: any) => {
		const findButtonGroup: any = (target: any, loop: number) => {
			const limitParents = 3;
			if (loop <= limitParents) {
				if (target.parentElement.getAttribute('data-epo') == `epo-buttongroup-${meta.version}`) {
					return target.parentElement;
				} else {
					return findButtonGroup(target.parentElement, loop + 1);
				}
			}
			return null;
		};

		let _buttongroupTarget = findButtonGroup(e.target, 0);

		if (_buttongroupTarget) {
			let newPosition = 0;
			let focussableElements;
			switch (e.key) {
				case 'ArrowRight':
					newPosition = (+_dataKey + 1) % _buttongroupTarget.childNodes.length;
					focussableElements = '[data-key="' + newPosition + '"]';
					_buttongroupTarget.querySelector(focussableElements).focus();
					break;
				case 'ArrowDown':
					newPosition = (+_dataKey + 1) % _buttongroupTarget.childNodes.length;
					focussableElements = '[data-key="' + newPosition + '"]';
					_buttongroupTarget.querySelector(focussableElements).focus();
					break;
				case 'ArrowLeft':
					newPosition = _dataKey == 0 ? _buttongroupTarget.childNodes.length - 1 : +_dataKey - 1;
					focussableElements = '[data-key="' + newPosition + '"]';
					_buttongroupTarget.querySelector(focussableElements).focus();
					break;
				case 'ArrowUp':
					newPosition = _dataKey == 0 ? _buttongroupTarget.childNodes.length - 1 : +_dataKey - 1;
					focussableElements = '[data-key="' + newPosition + '"]';
					_buttongroupTarget.querySelector(focussableElements).focus();
					break;
				case 'Tab':
					newPosition = _buttongroupTarget.childNodes.length - 1;
					focussableElements = '[data-key="' + newPosition + '"]';
					_buttongroupTarget.querySelector(focussableElements).focus();
					break;
			}
			if (e.shiftKey && e.key === "Tab") {
				newPosition = 0;
				focussableElements = '[data-key="' + newPosition + '"]';
				_buttongroupTarget.querySelector(focussableElements).focus();
			}
		}
	};

	const propsElement = disableKeyboardSupport
		? {
			...childrenProps,
			...item?.props,
			'data-key': dataKey,
			hideLabel: hideLabel,
			...rest,
			disabled: item?.props?.disabled
		}
		: {
			...childrenProps,
			...item?.props,
			'data-key': dataKey,
			hideLabel: hideLabel,
			onKeyDownCapture: (e: any) => focusNextElement(e, dataKey),
			...rest,
			disabled: item?.props?.disabled
		};

	return React.cloneElement(item, propsElement);
};

export const View = (props: IDummyProps) => {
	const { children, overrides, disableKeyboardSupport, orientation = "horizontal", hideLabel, ...rest } = props;
	const [css] = useStyletron();
	let shape;
	let buttonClassName;

	return (
		<ButtonGroup
			{...rest}
			overrides={overrides ? mergeOverrides(customOverrides(props) as any, overrides as any) : customOverrides(props) as any}
		>
			{React.Children.map(children, (item, index) => {
				shape = item.props.shape || props.shape || 'square';
				buttonClassName = buttonBaseStyles(props.theme, orientation);

				if (!props.shape || props.shape === 'default') {
					if (index === 0) {
						shape = item.props.shape || props.shape || orientation == 'vertical' ? 'first-vertical' : 'first';
						buttonClassName = firstButtonStyles(props.theme);
					}
					if (index === React.Children.toArray(props.children).length - 1) {
						shape = item.props.shape || props.shape || orientation == 'vertical' ? 'last-vertical' : 'last';
					}
				}

				return (
					<ToolbarButton
						hideLabel={hideLabel}
						item={item}
						key={index}
						dataKey={index}
						childrenProps={children.props}
						theme={props.theme}
						size={props.size}
						tabIndex="0"
						buttongroupShape={shape}
						role={props.mode == 'radio' ? 'radio' : 'button'}
						className={`${item?.props?.className} ${css({ ...buttonClassName })}`}
						disableKeyboardSupport={disableKeyboardSupport}
					/>
				);
			})}
		</ButtonGroup>
	);
};
